var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.646484,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#00A853"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6654 13.4797H15.6654V6.47974H13.332V13.4797H6.33203V15.8131H13.332V22.8131H15.6654V15.8131H22.6654V13.4797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPlus);
export default __webpack_public_path__ + "static/media/icons-plus.1bf4f30da878c61137c329b88039e781.svg";
export { ForwardRef as ReactComponent };